import { render } from "./FORTINET.vue?vue&type=template&id=4461285a"
import script from "./FORTINET.vue?vue&type=script&lang=ts"
export * from "./FORTINET.vue?vue&type=script&lang=ts"
script.render = render

export default script